import SelectBillingEntity from './select-billing-entity'

export default SelectBillingEntity